/* global firebase */

/*
 *  Firebase is installed with implicit initialization (https://firebase.googleblog.com/2017/04/easier-configuration-for-firebase-on-web.html)
 *  which allows us to easily use different firebase projects/environments. See index.html for the initialization.
 *  To bypass eslint, add the global tag (like line 1 above) to access the firebase global variable.
 */

import store from '../redux/store';
import { fetchUser, unsubscribe } from '../redux/actions/dataActions';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: `${process.env.REACT_APP_PROJECT_ID}.firebaseapp.com`,
    databaseURL: `https://${process.env.REACT_APP_PROJECT_ID}.firebaseio.com`,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: `${process.env.REACT_APP_PROJECT_ID}.appspot.com`,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const auth = app.auth();
export const storageRef = firebase.storage().ref();
export const storage = firebase.storage();
export const analytics = firebase.analytics();

auth.onAuthStateChanged(function(user) {
    if (user) {
        auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .then((_) => {
                return user.getIdTokenResult();
            })
            .then((idTokenResult) => {
                store.dispatch(fetchUser(user.uid, idTokenResult.claims.organizationId));
            })
            .catch((error) => {
                console.error("Unable to find organizationId on User's Auth Custom Claim\n" + error);
                unsubscribe();
            });
    } else {
        unsubscribe();
    }
});
